import {Box, VStack} from "@chakra-ui/react";
import {domToReact} from "html-react-parser";
import Deco from "../../../../images/decoElement.svg";
import Locked from "./images/locked.svg";
import {Formik} from "formik";
import {InputControl} from "formik-chakra-ui";
import CustomButton from "../customButton/customButton";
import * as React from "react";
import * as Yup from "yup";
import axios from "axios";
import {unlock} from "./unlockLockedContent";

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const onSubmit = (values,{ setSubmitting, setStatus, resetForm },formId) => {

    sleep(500).then(() => {
        setStatus();
        const formData = new FormData();
        let formId = '';
        for (const [key, value] of Object.entries(values)) {
            formData.append(key, value);
            if (key === 'formId') formId = value;
        }

        axios({
            method: "POST",
            url: process.env.CD_WP_API_JSON+'/cd-api/v1/newsletter-enroll/',
            data: formData,
            header: {
                'Content-Type': 'multipart/form-data'
            },
        }).then(res => {
            resetForm();
            setSubmitting(false);
            if (typeof window !== 'undefined') localStorage.setItem("mailUnlocked", JSON.stringify('1'));
            unlock();
        }).catch(err => {
            console.log('sending - error');
        });
    });
};

export default function NewsletterLockedContent({children, post, mailing}){

    const lang = post.language.code ?? 'PL'
    const validationMessage = {
        formatError : {
            PL : 'Błędny format adresu',
            EN : 'Incorrect email format'
        },
        emailRequired : {
            PL : 'E-Mail jest wymagany',
            EN : 'E-mail is required'
        }
    }
    const validationSchema = Yup.object({
        email: Yup.string().email(validationMessage.formatError[lang]).required(validationMessage.emailRequired[lang]),
    });

    const initialValues = {
        email: "",
        formId: 'newsletterUnlocker',
        uri : post.uri ?? null,
        group : mailing ? mailing.group : '127463516677342504'
    }

    const translations = {
        header : {
            PL: 'Treści i materiały dostępne po odblokowaniu',
            EN :'Content and materials available after unlocking'
        },
        info : {
            PL: 'Te treści dostępne są dla subskrybentów naszego newsletter’a.',
            EN :'This content is available to subscribers to our newsletter.'
        },
        infoDetails : {
            PL: 'Aby odblokować dostęp zapisz się. Raz w tygodniu otrzymasz wszystko, czego potrzebujesz, aby być na bieżąco z najnowszymi trendami w marketingu.',
            EN :'Sign up to unlock access. Once a week you will receive everything you need to stay up to date with the latest trends in marketing.'
        },
        moreDetails : {
            PL: 'Dowiedz się więcej.',
            EN :'Find out more.'
        },
        shareInfo : {
            PL: 'Podając adres e-mail wyrażasz zgodę na otrzymywanie treści na ten adres.',
            EN: 'By providing your e-mail address, you agree to receive content at this address.'
        },
        url : {
            PL: '/pl/polityka-prywatnosci/',
            EN :'/en/privacy-policy/'
        },
        urlTitle : {
            PL: 'Polityka prywatności',
            EN :'Privacy policy'
        },
        buttonText : {
            PL: 'Zapisz się',
            EN :'Sign up'
        }
    }

    return (
        <Box className={'slc'}>
            <Box className={'locked'} minHeight={{base:'650px', md:'550px', lg:'500px'}}>{domToReact(children)}</Box>
            <Box className={'slc-overlay'}>
                <Box position={'relative'}>
                    <Box as={Deco} position={'absolute'} top={'-1px'} right={'-1px'}/>
                    <Box as={Locked} />
                    <Box as={'h4'}>{translations.header[lang]}</Box>
                    <Box textAlign={'center'} fontSize={'15px'} fontWeight={'normal'} lineHeight={'26px'}>
                        {translations.info[lang]} <br/>{translations.infoDetails[lang]}
                    </Box>
                    <Box className={'slc-links'}>
                        <Formik
                            initialValues={initialValues}
                            onSubmit={onSubmit}
                            validationSchema={validationSchema}
                        >
                            {({ handleSubmit, status }) => (
                                <Box
                                    borderWidth="0"
                                    m="10px auto"
                                    as="form"
                                    onSubmit={handleSubmit}
                                    transition = 'all 0.3s'
                                >
                                    {status}
                                    <VStack spacing={{base:'20px', xxl: '40px'}} align="flex-start"
                                            p={'20px 0 0 0'}
                                            m={{base: '10px 20px', lg: "10px 0 0 0"}}
                                            w={{base:'100%', xxl: '100%'}}
                                            id={'newsletter-unlock'}
                                            flexDir={{ base: 'column', lg: 'row'}}
                                            className={'newsletterUnlocker'}
                                            transition = 'all 0.3s'
                                    >
                                        <InputControl name="email" label="E-mail" className={'abs'} id={'emailField'} transition = 'all 0.3s'
                                                      borderRadius={'0'} border={'0'}
                                                      placeholder= "E-mail"
                                                      onFocus = {(event) => {
                                                          document.getElementById('emailField-label').style.top = '-25px';
                                                      }}
                                                      onBlur = {(event) => {
                                                          if (event.target.defaultValue.trim().length > 0 ){
                                                              document.getElementById('emailField-label').classList.add('isFilled');
                                                          } else {
                                                              document.getElementById('emailField-label').style.top = '10px';
                                                              document.getElementById('emailField-label').classList.remove('isFilled');
                                                          }
                                                      }}/>
                                        <Box m={'0px'} w={{ base: '100%', lg: '300px'}}>
                                            <CustomButton fontSize={{base:'15px', lg: '12px', xxl:'15px'}} cursor={'pointer'} text={translations.buttonText[lang]} onClick={handleSubmit}
                                                          m={'0'} mx={{base:'auto', lg:'0'}} width={{base: 'calc(100%)', lg:'100%'}} textAlign={'left'} justifyContent={'flex-start'}
                                                          padding={{lg: '10px 40px 10px 20px'}}
                                            />
                                        </Box>
                                    </VStack>
                                </Box>
                            )}
                        </Formik>
                    </Box>
                    <Box mt='30px' fontSize={'11px'} w={'100%'} lineHeight={'18px'} fontWeight={'normal'}>{translations.shareInfo[lang]} <a href={translations.url[lang]} title={translations.urlTitle[lang]}>{translations.moreDetails[lang]}</a></Box>
                </Box>
            </Box>
        </Box>
    )
}